import React from 'react';

interface IRecebimento {
    id: number;
    valor: string;
    vencimento: string;
    status: 'R' | 'A';
    descricao: string;
    tipo_recebimento: 'Transferencia' | 'Gateway' | 'Boleto' | 'Cartão' | 'PIX';
}

interface PaymentCardProps {
    recebimento: IRecebimento;
    contratoId: number;
    onPagar: (id: number, contratoId: number, valor: string) => void;
}

const PaymentCard: React.FC<PaymentCardProps> = ({ recebimento, contratoId, onPagar }) => {
    const isPaid = recebimento.status === 'R';

    return (
        <div className={`payment-item ${isPaid ? 'paid' : 'unpaid'}`}>
            <div className="payment-item-left">
                <p className="payment-item-value">
                    R$ {parseFloat(recebimento.valor).toFixed(2)}
                </p>
                <p className="payment-item-desc">{recebimento.descricao}</p>
                <p className="payment-item-date">Vencimento: {recebimento.vencimento}</p>
            </div>

            <div className="payment-item-right">
                <span className={`payment-status ${isPaid ? 'paid' : 'pending'}`}>
                    {isPaid ? 'Pago' : 'Aguardando'}
                </span>
                <span className="payment-type">{recebimento.tipo_recebimento}</span>
                {!isPaid && (
                    <button
                        className="payment-btn"
                        onClick={() => onPagar(recebimento.id, contratoId, recebimento.valor)}
                    >
                        Pagar
                    </button>
                )}
            </div>
        </div>
    );
};

export default PaymentCard;
